import _ from "underscore";
// import moment from "moment";

import { 
	SETUP_TOPIC_STATS, 
	SYNC_RELEVANCY, 
	SET_ARTICLES_EXPANDED,
	SET_ENTITIES_EXPANDED,
	SET_FILTER_BY_MAP_COUNTRY,
	SET_MAP_HIDDEN_BY_FILTERS,
	RESET_ARTICLES_CURSOR_POS,
} from "actions/constants.js";

import { 
	fetchArticles, 
	fetchEntityFilters,
	fetchMapData, 
	fetchTimeseries
} from "actions/fetch";

import { 
	activateProposedFilters, 
	reactivateFilters, 
	getCountryFilters,
	addConfigFilters
} from "lib/helpers/filterHelpers.js";

import {
	updateDynamicFilters,
} from "actions/searchActions.js"

import { mergeEntityFilters } from "@exovera/helpers";
import { alignGraphDataTypeByPerspective, makeFetchKey } from "lib/helpers/helpers.js";

import { SEARCH_STATE_IDS } from "actions/constants/stateIds.js";

const stateId = SEARCH_STATE_IDS.NARRATIVES;
const CONTENT_PAGE_LENGTH = 50;

// updates the varStore
//		- allows projectConfig access to the initial store
// NOTE: Does not update any data
export function varStoreUpdate(parameters) {
	const { nar, perspective, currentZoom, activeFilters, mapHighlightId, contentFilteredByDate, entityFilters } = parameters;
	// narrative = object. Must have id & parent
	// activeFilters = array of any active filters or null
	// console.log(
	// 	"update varStore =>",
	// 	nar
	// 	// perspective,
	// 	// currentZoom,
	// 	// activeFilters,
	// 	// mapHighlightId,
	// 	// contentFilteredByDate
	// );

	return (dispatch) => {
		// prepare state
		dispatch({
			type: "varStoreUpdate", // ONLY updates varStore
			narrative: nar,
			perspective,
			activeFilters,
			currentZoom,
			entityFilters,
			mapHighlightId,
			contentFilteredByDate,
		});
	};
}

const checkMapHiddenByFilters = (hideMapFilters, activeFilters) => {
	let mapHidden = false;
	if (activeFilters) {
		const matchedTypes = {};
		for (let i=0; i<hideMapFilters.length; i++) {
			const hideMapFilter = hideMapFilters[i];
			matchedTypes[hideMapFilter.parent] = true;
			const matchedByTypeFilters = activeFilters.filter(x => {
				return x.parent === hideMapFilter.parent
			})
			if (matchedByTypeFilters.length > 0) {
				const idMatch = matchedByTypeFilters.find(x => { return x.id === hideMapFilter.id; });
				matchedTypes[hideMapFilter.parent] = matchedTypes[hideMapFilter.parent] && (!!idMatch);
			}
		}
		mapHidden = !Object.values(matchedTypes).every(
			value => value === true
		);
	}
	return mapHidden;
}

export const updateDataFromState = () => {
	return (dispatch, getState) => {
		const { 
			perspective, 
			contentFilteredByDate, 
			activeNarrativeData,
		} = getState().base; 

		const { 
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			currentZoom, 
			activeSearchObj,
		} = getState().search[stateId];

		const { 
			projectMapConfig, 
		} = getState().projectConfig;

		const { 
			varStore,
		} = getState().storage;

		const configStateFilter =
			projectMapConfig && projectMapConfig.narratives && projectMapConfig.narratives.state;

		// const baseFilters = perspective === "Source" 
		// ? getState().base.sourceFilters 
		// : getState().base.audienceFilters;

		// // Don't retain previous filters if there is a map config
		// const activeFilters = configStateFilter
		// 	? addConfigFilters([], configStateFilter, baseFilters)
		// 	: varStore.narratives[perspective].filters;

		const params = {
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			contentFilteredByDate,
			entityFilters: configStateFilter ? [] : varStore.narratives[perspective].entityFilters,
			currentZoom,
			mapHighlightId: configStateFilter ? configStateFilter.geoState : varStore.narratives[perspective].mapHighlightId,
			nar: activeNarrativeData,
			perspective,
			query: activeSearchObj.query,
		};

		return dispatch(updateData(params));
	}
}

// one action to update all data for the Narratives tab
//		Updates Map, Graph, Article, and Entities data
// 		Works with 'all'
export function updateData(parameters) {
	const {
		// activeFilters,
		contentFilteredByDate,
		// currentFilters, // not required
		entityFilters,
		currentZoom,
		dontUpdateMap,
		// keywords,
		mapHighlightId,
		nar,
		perspective,
		query,
		topicsPie,
		relevancyOverride,
	} = parameters;
	// // narrative = object. Must have id & parent
	// // activeFilters = array of any active filters or null
	// console.log(
	// 	"UD =>",
	// 	parameters
	// 	// 	// nar,
	// 	// 	// perspective,
	// 	// 	// currentZoom,
	// 	// 	// activeFilters,
	// 	// 	// mapHighlightId,
	// 	// 	// contentFilteredByDate,
	// 	// 	// dontUpdateMap,
	// 	// 	// entityFilters,
	// 	// 	// keywords
	// );
	const narrative = nar;

	return (dispatch, getState) => {
		const {
			graphDataTypes,
			hideMap,
			showAllTopicsMap,
			showTopicsInGraph,
			topPhrasesAvailable,
			topicStatsConfig,
			hideMapFilterIds,
		} = getState().projectConfig;

		const {
			articlesPageOffset,
			contentHeaderSortTypeSource,
			contentHeaderSortTypeAudience,
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			dmaAggregation,
			graphDataTypeActive,
			translateEntities,
			filterByMapCountry,
			currentMapCountryFilter,
		} = getState().base;

		const { 
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			currentEntityType,
			currentFiltersList,
			filters, 
		} = getState().search[stateId];

		// const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		// const currentFiltersForReal = activateProposedFilters(currentFilters || reactivateFilters(baseFilters, activeFilters || []));
		// REVISIT JA: NARR
		// const mergedFilters = formattedFilters;
		// const mergedFilters = mergeEntityFilters({
		// 	formattedFilters,
		// 	entityFilters,
		// 	keywords: [],
		// 	perspective,
		// });


		const relevancy = relevancyOverride || getState().base.relevancy;

		// Set the sort variables by perspective
		const contentHeaderSortType = perspective === "Source" ? contentHeaderSortTypeSource : contentHeaderSortTypeAudience;
		const contentHeaderSortAscending = perspective === "Source" ? contentHeaderSortAscendingSource : contentHeaderSortAscendingAudience;

		const numberOfLinesWithParent = narrative.children && narrative.children.length > 0 ? narrative.children.length + 1 : 1;
		const numberOfLinesWithoutParent = narrative.children && narrative.children.length > 0 ? narrative.children.length : 1;
		// Show parent timeseries if showTopicsInGraph or there are no children
		// Also, dont' fetch the base object
		const showTopicLine = (showTopicsInGraph && narrative.parent !== "self") || !narrative.children || narrative.children.length < 1;
		const showMap = !hideMap && (showTopicLine || (showAllTopicsMap && narrative.parent === "self"));

		// const alignedDataType = alignGraphDataTypeByPerspective({ perspective, graphDataTypeActive, graphDataTypes });

		const fetchKey = makeFetchKey(narrative, perspective, currentFiltersList, currentZoom, relevancy);
		dispatch({ type: "mostRecentFetch", fetchKey });

		// prepare state
		dispatch({
			type: "updateVariables", // ONLY updates varStore
			perspective,
			activeFilters: currentFiltersList,
			currentZoom,
			entityFilters,
			mapHighlightId,
			contentFilteredByDate,
		});
		
		// Check if map should be hidden based on configured filters
		if (hideMapFilterIds && hideMapFilterIds.length > 0) {
			const hidden = checkMapHiddenByFilters(hideMapFilterIds, currentFiltersList);
			dispatch({
				type: SET_MAP_HIDDEN_BY_FILTERS,
				hidden
			});
		}

		// Check if map country filtering should be disabled based on country filter configuration
		if (filterByMapCountry) {
			const activeCountryFilters = getCountryFilters(currentFiltersList);
			let foundInvalidCountry = false;
			for (let i=0; i<activeCountryFilters.length; i++) {
				if (currentMapCountryFilter !== activeCountryFilters[i].id) {
					foundInvalidCountry = true;
					break;
				}
			}
			if (foundInvalidCountry || activeCountryFilters.length === 0) {
				dispatch({type: SET_FILTER_BY_MAP_COUNTRY, value: false});
			}
		}

		dispatch({
			type: "requestTimeseries",
			// Show children plus their parent, or one narrative
			numberOfLines: showTopicsInGraph && narrative.parent !== "self" ? numberOfLinesWithParent : numberOfLinesWithoutParent,
			narrative,
		});

		// dispatch({ type: "requestArticles" });

		const startDate = contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin;
		const endDate = contentFilteredByDate ? Number(contentFilteredByDate.end) : currentZoom.end;
		const params = {
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			narrative,
			perspective,
			startDate,
			endDate,
			dataType: graphDataTypeActive,
			filters: filters || [],
			currentFilters: currentFiltersList,
			query,
			relevancy,
			stateCode: mapHighlightId,
			translateEntities,
			fetchKey,
		};

		const articleParams = {...params};
		articleParams.sortBy = contentHeaderSortType;
		articleParams.ascending = contentHeaderSortAscending;
		articleParams.pageLength = CONTENT_PAGE_LENGTH;
		articleParams.offset = articlesPageOffset;

		// Setup topic stats
		if (topicsPie && topicStatsConfig) {
			const allChildren = [];
			_.each(topicStatsConfig, (topic) => {
				_.each(topic.children, (child) => {
					allChildren.push(child);
				});
			});
			dispatch({ type: SETUP_TOPIC_STATS, topicStatsConfig, expectedNarratives: allChildren.length });
		}

		// Fetch Timeseries Data for narrative
		if (showTopicLine) {
			dispatch(fetchTimeseries(params));
		}

		// Fetch Timeries Data for all narrative children
		_.each(narrative.children, (trend) => {
			dispatch(
				fetchTimeseries({
					...params,
					narrative: trend,
				})
			);
		});

		// Fetch Map data
		if (showMap) {
			// sets or clears mapHighlightId (which will load the map in highlight mode)
			if (!dontUpdateMap) {
				dispatch({ type: "setMapHighlightId", mapHighlightId });
			}
			params.dmaAggregation = dmaAggregation;
			dispatch(fetchMapData(params));
		}

		// Fetch Articles Data
		dispatch(fetchArticles(articleParams));

		// No entities in Reaction mode
		if (perspective !== "Audience") {
			dispatch(fetchEntityFilters(stateId, currentEntityType));
		}
		dispatch({
			type: SYNC_RELEVANCY,
			payload: { relevancy, activeRelevancy: relevancy },
		});
		
		// Update Dynamic Filters
		dispatch(updateDynamicFilters(stateId));
	};
}

// TODO: - add an update function to incorporate the initial data fetch, which may include updateMapData FLAG_REFACTOR_DATA_JS

// one action to update all data for the Map in the Narratives tab
//		Updates Map only
// 		Works with 'all'
export function updateMapData(parameters) {
	const {
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		contentFilteredByDate,
		currentFiltersList,
		currentZoom,
		entityFilters,
		mapHighlightId,
		nar,
		perspective,
		query,
		updatedMapSegment,
	} = parameters;
	// // narrative = object. Must have id & parent
	// // activeFilters = array of any active filters or null
	// console.log(
	// 	"UMD =>",
	// 	parameters,
	// 	// 	// nar,
	// 	// 	// perspective,
	// 	// 	// currentZoom,
	// 	// 	// activeFilters,
	// 	mapHighlightId
	// 	// 	// contentFilteredByDate,
	// 	// 	// entityFilters,
	// 	// 	// keywords
	// );
	const narrative = nar;

	return (dispatch, getState) => {
		const { dmaAggregation, relevancy } = getState().base;
		const { filters } = getState().search[stateId];

		const fetchKey = makeFetchKey(narrative, perspective, currentFiltersList, currentZoom, relevancy);
		dispatch({ type: "mostRecentFetch", fetchKey });

		// // prepare state
		// dispatch({
		// 	type: "updateVariables", // ONLY updates varStore
		// 	perspective,
		// 	activeFilters,
		// 	currentZoom,
		// 	entityFilters,
		// 	mapHighlightId,
		// 	contentFilteredByDate,
		// });

		// REVISIT JA: NARR
		// const mergedFilters = mergeEntityFilters({
		// 	activeFilters,
		// 	entityFilters,
		// 	keywords,
		// 	perspective,
		// });

		const startDate = contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin;
		const endDate = contentFilteredByDate ? Number(contentFilteredByDate.end) : currentZoom.end;

		// TODO: See if this is needed
		// sets or clears mapHighlightId (which will load the map in highlight mode)
		// if (!dontUpdateMap) {
		// 	dispatch({ type: "setMapHighlightId", mapHighlightId });
		// }
		dispatch(
			fetchMapData({
				activeSearchTranslationEnabled,
				activeSearchTranslationLanguages,
				dmaAggregation,
				currentFilters: currentFiltersList,
				currentMapSegmentSpan: updatedMapSegment,
				endDate,
				fetchKey,
				filters: filters || [],
				narrative,
				perspective,
				query,
				relevancy,
				startDate,
				stateCode: mapHighlightId,
			})
		);
	};
}

export function updateCurrentMapData() {
	return (dispatch, getState) => {
		const {
			activeNarrativeData,
			contentFilteredByDate,
			entityFilters,
			mapHighlightId,
			perspective,
			currentMapSegmentSpan,
		} = getState().base;

		const { 
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			activeSearchObj,
			currentFiltersList,
			currentZoom, 
		} = getState().search[stateId];
		
		return () => dispatch(
			updateMapData({
				activeSearchTranslationEnabled,
				activeSearchTranslationLanguages,
				activeFilters: currentFiltersList,
				contentFilteredByDate,
				currentFiltersList,
				currentZoom,
				entityFilters,
				nar: activeNarrativeData,
				mapHighlightId,
				perspective,
				query: activeSearchObj.query,
				updatedMapSegment: currentMapSegmentSpan,
			})
		);
	}
}

// Only updates the graph data. Designed to support Graph's dataType feature
export function updateGraphData(parameters) {
	const { dataType } = parameters;

	return (dispatch, getState) => {
		const {
			activeNarrativeData,
			contentFilteredByDate,
			entityFilters,
			perspective,
			relevancy,
		} = getState().base;

		const {
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			activeSearchObj,
			currentFiltersList,
			currentZoom,
			filters,
		} = getState().search[stateId];

		const { showTopicsInGraph } = getState().projectConfig;
		const narrative = activeNarrativeData;

		const numberOfLinesWithParent = narrative.children && narrative.children.length > 0 ? narrative.children.length + 1 : 1;
		const numberOfLinesWithoutParent = narrative.children && narrative.children.length > 0 ? narrative.children.length : 1;

		const fetchKey = makeFetchKey(narrative, perspective, currentFiltersList, currentZoom, relevancy);
		dispatch({ type: "mostRecentFetch", fetchKey });

		dispatch({
			type: "requestTimeseries",
			// Show children plus their parent, or one narrative
			numberOfLines: showTopicsInGraph && narrative.parent !== "self" ? numberOfLinesWithParent : numberOfLinesWithoutParent,
			narrative,
		});
		// dispatch({ type: "requestArticles" });

		// REVISIT JA: NARR
		// const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		// const currentFiltersForReal = activateProposedFilters(reactivateFilters(baseFilters, currentFiltersList));
		// const mergedFilters = mergeEntityFilters({
		// 	activeFilters: currentFiltersList,
		// 	entityFilters,
		// 	keywords: activeKeywords,
		// 	perspective,
		// });

		const startDate = contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin;
		const endDate = contentFilteredByDate ? Number(contentFilteredByDate.end) : currentZoom.end;

		const params = {
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			currentFilters: currentFiltersList,
			dataType,
			endDate,
			fetchKey,
			filters: filters || [],
			narrative,
			perspective,
			query: activeSearchObj.query,
			relevancy,
			startDate,
		};

		// Fetch overall timeseries for narrative
		dispatch(fetchTimeseries(params));

		// Fetch timeseries data for each child of narrative
		_.each(narrative.children, (trend) => {
			dispatch(
				fetchTimeseries({
					...params,
					narrative: trend,
					parent: narrative,
				})
			);
		});
	};
}

// one action to update Articles and Entities for the Narratives tab
//		For use with zooming the graph
// 		Works with 'all'
export function updateLowerData(parameters) {
	const { 
		contentFilteredByDate, 
		// currentFiltersList,
		currentZoom, 
		// entityFilters, 
		// filters,
		dontUpdateMap = false,
		nar, 
		offset,
		pageLength,
		perspective,
		query,
		dontUpdateDynamicFilters,
	} = parameters;

	const narrative = nar;

	return (dispatch, getState) => {
		const {
			contentHeaderSortTypeSource,
			contentHeaderSortTypeAudience,
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			dmaAggregation,
			mapHighlightId,
			relevancy,
			translateEntities,
		} = getState().base;

		const { 
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			currentEntityType,
			currentFiltersList,
			filters,
		} = getState().search[stateId];

		const {
			hideMap,
			showAllTopicsMap,
			showTopicsInGraph,
			topPhrasesAvailable,
		} = getState().projectConfig;


		// Set the sort variables by perspective
		const contentHeaderSortType = perspective === "Source" ? contentHeaderSortTypeSource : contentHeaderSortTypeAudience;
		const contentHeaderSortAscending = perspective === "Source" ? contentHeaderSortAscendingSource : contentHeaderSortAscendingAudience;

		const fetchKey = makeFetchKey(narrative, perspective, currentFiltersList, currentZoom, relevancy);
		dispatch({ type: "mostRecentFetch", fetchKey });

		// prepare state
		dispatch({
			type: "updateLowerVariables", // ONLY updates varStore
			narrative,
			perspective,
			currentZoom,
			contentFilteredByDate,
		});

		// dispatch({ type: "requestArticles" });

		// REVISIT JA: NARR
		// const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		// const currentFilters = activateProposedFilters(reactivateFilters(baseFilters, activeFilters || []));
		// const mergedFilters = mergeEntityFilters({
		// 	activeFilters,
		// 	entityFilters,
		// 	keywords,
		// 	perspective,
		// });

		const params = {
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			currentFilters: currentFiltersList,
			endDate: contentFilteredByDate? Number(contentFilteredByDate.end)	: currentZoom.end,
			fetchKey,
			filters: filters || [],
			narrative,
			perspective,
			query,
			relevancy,
			startDate: contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin,
			translateEntities,
		};

		const articleParams = {...params};
		articleParams.sortBy = contentHeaderSortType;
		articleParams.ascending = contentHeaderSortAscending;
		articleParams.pageLength = pageLength !== undefined ? pageLength : CONTENT_PAGE_LENGTH;
		articleParams.offset = offset !== undefined ? offset : getState().base.articlesPageOffset;


		// Fetch Map data
		const showTopicLine = (showTopicsInGraph && narrative.parent !== "self") || !narrative.children || narrative.children.length < 1;
		const showMap = !hideMap && (showTopicLine || (showAllTopicsMap && narrative.parent === "self"));
		if (showMap) {
			// sets or clears mapHighlightId (which will load the map in highlight mode)
			if (!dontUpdateMap) {
				dispatch({ type: "setMapHighlightId", mapHighlightId });
			}
			params.dmaAggregation = dmaAggregation;
			dispatch(fetchMapData(params));
		}
		
		// Fetch Articles
		dispatch(fetchArticles(articleParams));

		// Fetch Entities (no entities in Reaction mode)
		if (perspective !== "Audience") {
			dispatch(fetchEntityFilters(stateId, currentEntityType));
		}

		// Update Dynamic Filters
		if(!dontUpdateDynamicFilters) {
			 dispatch(updateDynamicFilters(stateId));
		}
	};
}

// one action to update Articles and Entities for the Narratives tab
//		For use with updateContentByDate. Stores the indicator (or clears it)
// 		Works with 'all'
export function updateDataByDate(parameters) {
	const { 
		contentFilteredByDate, 
		currentZoom, 
		entityFilters, 
		nar, 
		offset,
		pageLength,
		perspective,
		query,
	} = parameters;

	// narrative = object. Must have id & parent
	// activeFilters = array of any active filters or null
	// console.log("Update Data by date =>", activeFilters, contentFilteredByDate);
	const narrative = nar;

	return (dispatch, getState) => {
		const {
			contentHeaderSortTypeSource,
			contentHeaderSortTypeAudience,
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			relevancy,
			translateEntities,
		} = getState().base;

	const { 
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		currentEntityType,
		currentFiltersList,
		filters,
	} = getState().search[stateId];

		const { topPhrasesAvailable } = getState().projectConfig;

		// Set the sort variables by perspective
		const contentHeaderSortType = perspective === "Source" ? contentHeaderSortTypeSource : contentHeaderSortTypeAudience;
		const contentHeaderSortAscending = perspective === "Source" ? contentHeaderSortAscendingSource : contentHeaderSortAscendingAudience;

		const fetchKey = makeFetchKey(narrative, perspective, currentFiltersList, currentZoom, relevancy);
		dispatch({ type: "mostRecentFetch", fetchKey });

		// prepare state
		dispatch({
			type: "updateVariablesByDate", // ONLY updates varStore
			narrative,
			perspective,
			contentFilteredByDate,
		});

		// dispatch({ type: "requestArticles" });

		// REVISIT JA: NARR
		// const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		// const currentFilters = activateProposedFilters(reactivateFilters(baseFilters, activeFilters || []));
		// const mergedFilters = mergeEntityFilters({
		// 	activeFilters,
		// 	entityFilters,
		// 	keywords,
		// 	perspective,
		// });

		const params = {
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			currentFilters: currentFiltersList,
			endDate: contentFilteredByDate ? Number(contentFilteredByDate.end) : currentZoom.end,
			fetchKey,
			filters: filters || [],
			narrative,
			perspective,
			query,
			relevancy,
			startDate: contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin,
			translateEntities,
		};

		const articleParams = {...params};
		articleParams.sortBy = contentHeaderSortType;
		articleParams.ascending = contentHeaderSortAscending;
		articleParams.pageLength = pageLength !== undefined ? pageLength : CONTENT_PAGE_LENGTH;
		articleParams.offset = offset !== undefined ? offset : getState().base.articlesPageOffset;

		// Fetch Articles
		dispatch(fetchArticles(articleParams));

		// Fetch Entities (no entities in Reaction mode)
		if (perspective !== "Audience") {
			dispatch(fetchEntityFilters(stateId, currentEntityType));
		}

		// Update Dynamic Filters
		dispatch(updateDynamicFilters(stateId));
	};
}

// Updates the articles
//		For use with duplicate article toggle
// 		Works with 'all'
export function updateArticleData(parameters) {
	const { showDuplicates } = parameters;

	return (dispatch, getState) => {
		const { 
			contentFilteredByDate, 
			entityFilters, 
			perspective,
			contentHeaderSortTypeSource,
			contentHeaderSortTypeAudience,
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			relevancy,
		} = getState().base;

		const {
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			currentFiltersList,
			filters,
			activeSearchObj,
			currentZoom,
		} = getState().search[stateId];

		const narrative = getState().base.activeNarrativeData;

		// Set the sort variables by perspective
		const contentHeaderSortType = perspective === "Source" ? contentHeaderSortTypeSource : contentHeaderSortTypeAudience;
		const contentHeaderSortAscending = perspective === "Source" ? contentHeaderSortAscendingSource : contentHeaderSortAscendingAudience;

		const fetchKey = makeFetchKey(narrative, perspective, currentFiltersList, currentZoom);
		dispatch({ type: "mostRecentFetch", fetchKey });

		// prepare state
		// dispatch({ type: "requestArticles" });

		// REVISIT JA: NARR
		// const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		// const currentFilters = activateProposedFilters(reactivateFilters(baseFilters, activeFilters || []));
		// const mergedFilters = mergeEntityFilters({
		// 	activeFilters,
		// 	entityFilters,
		// 	keywords: activeKeywords,
		// 	perspective,
		// });

		dispatch(
			fetchArticles({
				activeSearchTranslationEnabled,
				activeSearchTranslationLanguages,
				ascending: contentHeaderSortAscending,
				currentFilters: currentFiltersList,
				endDate: contentFilteredByDate ? Number(contentFilteredByDate.end) : currentZoom.end,
				fetchKey,
				filters: filters || [],
				narrative,
				perspective,
				query: activeSearchObj.query,
				relevancy,
				showDuplicates,
				sortBy: contentHeaderSortType,
				startDate: contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin,
			})
		);
	};
}

// one action to update Entities for the Narratives tab
//		For use with the translate endities toggle
// 		Works with 'all'
export function updateEntityData() {
	// narrative = object. Must have id & parent
	// activeFilters = array of any active filters or null

	return (dispatch, getState) => {
		const {
			activeNarrativeData,
			contentFilteredByDate,
			entityFilters,
			perspective,
			relevancy,
		} = getState().base;

		const {
			activeSearchObj,
			currentEntityType,
			currentFiltersList,
			currentZoom,
			filters,
		} = getState().search[stateId];

		const narrative = activeNarrativeData;

		const fetchKey = makeFetchKey(narrative, perspective, currentFiltersList, currentZoom, relevancy);
		dispatch({ type: "mostRecentFetch", fetchKey });

		// prepare state
		dispatch({
			type: "updateLowerVariables", // ONLY updates varStore
			narrative,
			perspective,
			currentZoom,
			contentFilteredByDate,
		});

		// Fetch Entities (no entities in Reaction mode)
		if (perspective !== "Audience") {
			dispatch(fetchEntityFilters(stateId, currentEntityType));
		}
	};
}

export const setEntitiesExpanded = (expanded) => {
	return { type: SET_ENTITIES_EXPANDED, expanded };
};

export const setArticlesExpanded = (expanded) => {
	return { type: SET_ARTICLES_EXPANDED, expanded };
};

export function updateTranslatableComponents() {
	return (dispatch, getState) => {
		const { activeNarrativeData, perspective, activeKeywords } = getState().base;
		const { activeSearchObj, currentZoom } = getState().search[stateId];
		const { varStore } = getState().storage;
		if (varStore.narratives) {
			// debugger; // eslint-disable-line no-debugger
			dispatch({ type: RESET_ARTICLES_CURSOR_POS });
			dispatch(
				updateLowerData({
					nar: activeNarrativeData,
					perspective,
					currentZoom,
					activeFilters: varStore.narratives[perspective].filters,
					entityFilters: varStore.narratives[perspective].entityFilters,
					keywords: activeKeywords,
					mapHighlightId: varStore.narratives[perspective].mapHighlightId,
					query: activeSearchObj.query,
					contentFilteredByDate: false,
					offset: 0,
					dontUpdateDynamicFilters: true,
				})
			);
		}
	};
};